"use strict";
/**
 * Study Type Catalog Types
 *
 * Catalog of available study types (LAB or IMAGING) used when creating
 * an ExternalStudy. Some entries are "flexible" — they require a free-text
 * detail at use time (e.g. "USG dirigido" → user types "USG cardíaco").
 *
 * Seeded initially from QVET catalog (SERVICIOS EXTERNOS → LABORATORIO/GABINETE)
 * cross-referenced with sales activity. Anyone can add new entries via UI.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.STUDY_CATEGORY_LABELS = exports.StudyCategory = void 0;
/**
 * Study category — determines the overdue threshold and groups studies.
 */
var StudyCategory;
(function (StudyCategory) {
    StudyCategory["LAB"] = "LAB";
    StudyCategory["IMAGING"] = "IMAGING";
})(StudyCategory || (exports.StudyCategory = StudyCategory = {}));
exports.STUDY_CATEGORY_LABELS = {
    [StudyCategory.LAB]: 'Laboratorio',
    [StudyCategory.IMAGING]: 'Imagen',
};
